/**
 *  update by tannc 2018年12月24日20:33:50
 */

import {
  DEV_SAVE_API,
  DEV_LIST_API,
  DEV_OPEN_API,
  DEV_RENEW_API,
  DEV_OPEN_ENABLE_API,
  DEV_OPEN_DISABLE_API,
  DEV_MODIFY_API,
  DEV_MODIFY_INFO_API,
  DEV_RESOURCE_API,
  DEV_APPLY_API,
  DEV_UPDATE_REMARK_API,
  DEV_RESOURCE_HISTORY_API,
  GET_DEVELOP_STATISTICS,
  GET_DELAY,
  GET_RESOURCE_PERMISSION,
  DEVELOP_BATCH_OPEN,
  GET_DEV_STATUS,
  SET_DEV_STATUS_PASS,
  SET_DEV_STATUS_REJECT,
  SET_DEV_ZUHE_OPEN,
  GET_DEV_ZUHE_OPEN,
  GET_DEV_ZUHE_OPEN_USER,
  DEL_DEV_ZUHE_OPEN
} from '../resource/index'
import axios from '../config/axios.config'
export default {
  async saveDev (data) {
    return await axios.save(DEV_SAVE_API, {}, data)
  },
  async listDev (params) {
    return await axios.get(DEV_LIST_API, params)
  },
  async openDev (data) {
    return await axios.save(DEV_OPEN_API, {}, data)
  },
  async renewDev (data) {
    return await axios.update(DEV_RENEW_API, {}, data)
  },
  async enableDev (id) {
    return await axios.update(DEV_OPEN_ENABLE_API, {id}, {})
  },
  async disableDev (id) {
    return await axios.update(DEV_OPEN_DISABLE_API, {id}, {})
  },
  async invokeNum (id, data) {
    return await axios.update(DEV_MODIFY_API, {id}, data)
  },
  async devModifyInfo (id, data) {
    return await axios.save(DEV_MODIFY_INFO_API, {id}, data)
  },
  async fetchDevResource (id) {
    return await axios.get(DEV_RESOURCE_API, {id})
  },
  async fetchDevResourceHistory (params) {
    return await axios.get(DEV_RESOURCE_HISTORY_API, params)
  },
  async listApplyUser (data) {
    return await axios.get(DEV_APPLY_API, data)
  },
  async updateRemark (data) {
    return await axios.update(DEV_UPDATE_REMARK_API, data, {})
  },
  // 获取开发者接口管理列表
  async getDevelopStatistics (params) {
    return axios.get(GET_DEVELOP_STATISTICS, params)
  },
  // 试用用户一键延期7天
  async getDelay (params) {
    return axios.update(GET_DELAY, params, {})
  },
  // 获取单个的资源调用权限
  async getResourcePermiss (params) {
    return axios.get(GET_RESOURCE_PERMISSION, params)
  },
  // 批量开通资源（用户或过期用户）
  async batchOpenResource (params) {
    return axios.save(DEVELOP_BATCH_OPEN, {}, params)
  },
  // 获取开发者状态
  async getDeveloperStatus (params) {
    return axios.get(GET_DEV_STATUS, params)
  },
  // 开发者审核通过
  async setDeveloperStatusPass (params) {
    return axios.save(SET_DEV_STATUS_PASS, params, {})
  },
  // 开发者审核拒绝
  async setDeveloperStatusReject (params) {
    return axios.save(SET_DEV_STATUS_REJECT, params, {})
  },
  // 获取组合开通
  getUserZuheOpen(params) {
    return axios.get(GET_DEV_ZUHE_OPEN_USER, params)
  },
  // 获取组合开通
  getZuheOpen(params) {
    return axios.get(GET_DEV_ZUHE_OPEN, params)
  },
  // 设置组合开通
  setZuheOpen(params) {
    return axios.save(SET_DEV_ZUHE_OPEN, {}, params)
  },
  // 设置组合开通
  delZuheOpen(params) {
    return axios.remove(DEL_DEV_ZUHE_OPEN, params)
  }
}



// WEBPACK FOOTER //
// ./src/service/devService.js